import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CheckOutSummary } from '../../components/CheckOutSummary';
import { GenerateAuthForm } from '../../components/GenerateAuthForm';
import { VerifyAuthCodeForm } from '../../components/VerifyAuthCodeForm';
import { CheckOut, Context } from '../../types';
import PageLayout from '../../components/PageLayout';

const useStyles: any = makeStyles((theme: any) => ({
  alertContainer: {
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1, 2, 0),
    },
  },
  content: {
    borderTop: `1px solid ${theme.palette.grey['300']}`,
    backgroundColor: theme.palette.grey['100'],
    borderRadius: '0 0 4px 4px',
  },
}));

type Props = {
  mobileNumber: string;
  checkOut: CheckOut;
  step: number;
  context: Context;
  getPaymentsCode: (mobileNumber: string) => Promise<any>;
  getPaymentsTokenByAuthCode: (values: { pin: string }, mobileNumber: string) => Promise<any>;
  setLoginStep: (step: number) => void;
};

const Login = (props: Props) => {
  const { checkOut, mobileNumber, step, context, getPaymentsCode, getPaymentsTokenByAuthCode, setLoginStep } = props;
  const classes = useStyles();
  const [stateError, setErrorState] = useState('');

  const form =
    step === 0 ? (
      <GenerateAuthForm
        getPaymentsCode={getPaymentsCode}
        mobileNumber={mobileNumber}
        checkOutId={checkOut && checkOut.id}
        stateError={stateError}
        setLoginStep={setLoginStep}
        setError={setErrorState}
      />
    ) : (
      <VerifyAuthCodeForm
        getPaymentsTokenByAuthCode={getPaymentsTokenByAuthCode}
        setLoginStep={setLoginStep}
        mobileNumber={mobileNumber}
        checkOutId={checkOut && checkOut.id}
        context={context}
        stateError={stateError}
        setError={setErrorState}
      />
    );

  return (
    <PageLayout pageTitle='Confirm purchase'>
      <CheckOutSummary />
      {checkOut && <Grid className={classes.content}>{form}</Grid>}
    </PageLayout>
  );
};

export default Login;
